<template lang="html">
  <server-form
    v-slot="slotProps"
    :form-action="formAction"
    :form="form"
    :submit-btn="{ text: showShare ? (noSharedObservers ? __('start_goal_without_sharing') : __('start_and_share_goal')) : __('start_goal') }">

    <div
      v-if="showShare"
      class="container mb-4"
    >
      <div
        v-for="(observer, key) in observers"
        :key="key"
        class="row">
        <div class="d-flex justify-content-between w-100 border-bottom d-flex align-items-center py-2">
          <p class="m-0 w-100">{{ observer.name }}<small><i>({{ observer.email }})</i></small></p>
          <p class="m-0 w-100"><strong>{{ getRoleLabelFromValue(observer.role) }}</strong></p>
          <div class="w-100 d-flex justify-content-end">
            <button
              :class="{'btn btn-sm': true, 'btn-outline-secondary': !observerIsShared(key), 'btn-secondary': observerIsShared(key)}"
              @click="($event) => observerShareClick($event, key, observer)">
              {{ observerIsShared(key) ? __('sharing') : __('share') }}
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <span :class="{'badge': true, 'badge-primary': !noSharedObservers, 'badge-danger': noSharedObservers}">
          {{
            sharedObserversCount === 1 ?
            __('sharing_with_observers_singular', [{ 'shared_observer_count': sharedObserversCount }]) :
            __('sharing_with_observers', [{ 'shared_observer_count': sharedObserversCount }])
          }}
        </span>
      </div>
    </div>

    <div class="mt-4 pt-4">
      <p>{{ __('development_goal_length_text') }}</p>

      <my360Select
        :form="form"
        :error-bag="slotProps.errors"
        :label="__('label_development_period_length')"
        :generic-error-msg="__('feedback_development_period_length')"
        :options="mergedDevGoalPeriods"
        value-key="value"
        label-key="label"
        class="vue-input-white"
        required
        prop="period"/>
    </div>

    <input
      v-for="(observer, key) in sharedObservers"
      :key="key"
      :value="key"
      :name="`shared_with[${observer.id}]`"
      type="hidden">
    <input
      :value="behaviourId"
      type="hidden"
      name="behaviour_id">

  </server-form>
</template>
<script>
import formAction from '../mixins/formAction'
import hasObserverTypes from '../mixins/hasObserverTypes'
import filter from 'lodash.filter'

export default {
  name: 'ConfirmDevelopmentGoal',

  mixins: [formAction, hasObserverTypes],

  props: {
    showShare: {
      type: Boolean,
      required: false,
      default: () => { return true }
    },
    behaviourId: {
      type: [String, Number],
      required: true
    },
    observers: {
      type: Array,
      required: false,
      default: () => { return [{ name: 'Same Jones', email: 'test@example.com', role: 'Peer' }, { name: 'Kyle B', email: 'test@example.com', role: 'Peer' }, { name: 'Dave', email: 'test@example.com', role: 'Peer' }] }
    },
    devGoalPeriods: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },

  data () {
    return {
      form: {
        period: 28
      },
      internalObservers: {}
    }
  },

  computed: {
    defaultDevGoalPeriods () {
      return [
        {
          label: this.__('4_weeks'),
          value: 28
        },
        {
          label: this.__('6_weeks'),
          value: 42
        },
        {
          label: this.__('8_weeks'),
          value: 56
        },
        {
          label: this.__('12_weeks'),
          value: 84
        }
      ]
    },

    mergedDevGoalPeriods () {
      return [
        ...this.defaultDevGoalPeriods,
        ...this.devGoalPeriods
      ]
    },

    sharedObservers () {
      return filter(this.internalObservers, 'share')
    },

    sharedObserversCount () {
      return this.sharedObservers.length
    },

    noSharedObservers () {
      if (!this.showShare) {
        return false
      }
      return this.sharedObserversCount === 0
    }
  },

  mounted () {
    this.internalObservers = {
      ...this.internalObservers,
      ...this.observers
    }
  },

  methods: {
    observerIsShared (key) {
      if (this.internalObservers[key]) {
        return this.internalObservers[key].share
      }
      return false
    },

    observerShareClick ($event, key, observer) {
      $event.preventDefault()
      this.$set(this.internalObservers[key], 'share', !this.internalObservers[key].share)
    }
  }
}
</script>
